<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper floatCss"
    >
      <div class="personalData-wrapper floatCss">
        <div class="personalData-header floatCss">
          <b-row>
            <b-col cols="12">
              <div class="pdc-tittle-bar floatCss">
                <div class="pdc-back">
                  <div class="pdc-back-btn">
                    <b-button
                      class="pdc-btn-1"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <div class="pdc-tittle-block">
                    <h3>Personal data consent</h3>
                  </div>
                </div>
                <div class="pdc-right-block">
                  <h3>{{ transferRequest.lotLocation }} / {{ transferRequest.nvsFileType }} • {{ transferRequest.lotType }}</h3>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="personalData-content floatCss">
          <b-row>
            <b-col cols="12">
              <div class="personalData-content-info floatCss">
                <p>I further declare that the Company has made available to me, the Company’s Customer Privacy Policy Statement (“Statement”) as required under the Personal Data Protection Act (Act 26 of 2012), and having read and inspected the same, hereby agree that I consent to the Company processing my personal data, and confirm that I have authority to provide the personal data of any third parties for processing by the Company in accordance with the Notice. </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="personalData-checkbox-group floatCss">
                <b-form-group>
                  <b-form-radio
                    v-model="agreeOption"
                    name="some-radios"
                    value="yes"
                  >
                    Yes, I agree
                  </b-form-radio>
                  <b-form-radio
                    v-model="agreeOption"
                    name="some-radios"
                    value="no"
                  >
                    No, I disagree
                  </b-form-radio>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="Purchaserdetails-bottom pdc-bottom floatCss">
        <b-row>
          <b-col cols="12">
            <b-button
              class="pr-btn-2"
              @click="savePersonalDataConsent"
            >
              Save personal data consent
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal
      id="modal-draft"
      v-model="showWarningModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      dialog-class="draft-modal mini_modal personal_data_consent_modal"
    >
      <div class="modal-content-wrapper">
        <h3>The Personal Data Consent clause is a requirement for us to process your sales submission.</h3>
        <p>
          Change to ‘Yes, I agree’ to continue.
        </p>
      </div>
      <div class="modal-content-bottom">
        <b-button
          class="pr-btn-3"
          @click="cancelConsent()"
        >
          Cancel
        </b-button>
        <b-button
          class="pr-btn-4"
          @click="changeToYes()"
        >
          Change to “Yes, I agree”
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormGroup, BFormRadio,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormRadio,
    AppLoader,
  },
  data() {
    return {
      sameAsCorrespondence: true,
      showMessage: false,
      showWarningModal: false,
      tokenDetail: {},
      transferRequest: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      agreeOption: 'yes',
    }
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.packageName = response.data.packageName
              if (this.transferRequest.currentStatus === 'Pending NP') {
                this.showMessage = true
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'You have already completed this step',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    savePersonalDataConsent() {
      if (this.agreeOption === 'yes') {
        localStorage.setItem('fileTransferDraft_personalConsent', JSON.stringify({ agreeOption: this.agreeOption }))
        this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
      } else {
        this.showWarningModal = true
      }
    },
    changeToYes() {
      this.agreeOption = 'yes'
      localStorage.setItem('fileTransferDraft_personalConsent', JSON.stringify({ agreeOption: 'yes' }))
      this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
    },
    cancelConsent() {
      this.showWarningModal = false
      // localStorage.removeItem('fileTransferDraft_personalConsent')
      // this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
    },
  },
}
</script>
